import React from 'react';
import { Box, Container, Paper, Stack, Typography, Alert } from '@mui/material';
import MainLayout from '../../../components/layout/MainLayout';

const DocumentsPage: React.FC = () => {
  return (
    <MainLayout>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Stack spacing={2} sx={{ mb: 3 }}>
          <Box>
            <h2 style={{ margin: 0 }}>Documents</h2>
            <p style={{ margin: '4px 0 0 0', color: '#666', fontSize: '14px' }}>Safe upload and categorization for Aadhaar, PAN, Resume, Offer Letter, Certificates</p>
          </Box>
        </Stack>

        <Paper sx={{ p: 3 }}>
          <Alert severity="info">
            Document management feature allows uploading and organizing staff documents like Aadhaar, PAN, Resume, Offer Letters, and Certificates. Access this through individual staff member profiles.
          </Alert>
        </Paper>
      </Container>
    </MainLayout>
  );
};

export default DocumentsPage;
